import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';

export default function Products() {
  const { t } = useTranslation('common');
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const products = [
    {
      image: 'https://public.readdy.ai/ai/img_res/b0c2a02dbf087c8a181a288c3686c2fe.jpg',
      title: t('products.product1'),
      description: t('products.product1Desc'),
      brand: 'Milgard',
      link: '/vinyl-windows'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Warm%20inviting%20kitchen%20with%20sleek%20aluminum%20frame%20window%2C%20soft%20natural%20daylight%20filtering%20through%20modern%20window%20into%20cozy%20cooking%20space%2C%20gentle%20ambient%20lighting%20on%20clean%20countertops%20with%20fresh%20ingredients%2C%20peaceful%20contemporary%20kitchen%20interior%20with%20warm%20wood%20tones%20and%20soft%20shadows%2C%20comfortable%20home%20atmosphere%20with%20natural%20materials%20and%20delicate%20light&width=600&height=800&seq=prod-alum-soft-302&orientation=portrait',
      title: t('products.product2'),
      description: t('products.product2Desc'),
      brand: 'Milgard',
      link: '/aluminum-windows'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Gentle%20sunlight%20through%20large%20sliding%20glass%20door%20opening%20to%20peaceful%20garden%2C%20soft%20natural%20light%20illuminating%20cozy%20living%20room%20with%20comfortable%20furniture%2C%20serene%20indoor%20outdoor%20connection%20with%20warm%20ambient%20glow%2C%20tranquil%20modern%20home%20interior%20with%20delicate%20shadows%20and%20inviting%20atmosphere%2C%20peaceful%20residential%20space%20with%20lush%20greenery%20visible%20outside%20and%20soft%20pastel%20interior%20tones&width=600&height=800&seq=prod-slide-soft-303&orientation=portrait',
      title: t('products.product3'),
      description: t('products.product3Desc'),
      brand: 'Milgard',
      link: '/sliding-doors'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Elegant%20French%20door%20with%20soft%20natural%20light%20creating%20warm%20welcoming%20entryway%2C%20gentle%20morning%20glow%20through%20classic%20door%20glass%20panels%20into%20cozy%20foyer%2C%20peaceful%20home%20entrance%20with%20delicate%20shadows%20and%20inviting%20atmosphere%2C%20serene%20residential%20interior%20with%20warm%20wood%20floors%20and%20soft%20ambient%20lighting%2C%20tranquil%20modern%20home%20with%20comfortable%20furnishings%20and%20natural%20materials&width=600&height=800&seq=prod-french-soft-304&orientation=portrait',
      title: t('products.product4'),
      description: t('products.product4Desc'),
      brand: 'Milgard',
      link: '/french-doors'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Serene%20spa-like%20bathroom%20with%20frameless%20glass%20shower%20enclosure%2C%20soft%20diffused%20natural%20light%20creating%20peaceful%20bathing%20space%2C%20gentle%20ambient%20glow%20on%20warm%20neutral%20tiles%20and%20natural%20stone%2C%20tranquil%20modern%20bathroom%20with%20delicate%20shadows%20and%20inviting%20atmosphere%2C%20comfortable%20luxury%20bathroom%20with%20soft%20textures%20and%20calming%20color%20palette&width=600&height=800&seq=prod-shower-soft-305&orientation=portrait',
      title: t('products.product5'),
      description: t('products.product5Desc'),
      brand: 'Milgard',
      link: '/shower-doors'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20natural%20wood%20window%20with%20warm%20grain%20texture%20in%20cozy%20living%20room%2C%20soft%20golden%20hour%20sunlight%20streaming%20through%20premium%20wood%20frame%2C%20gentle%20ambient%20lighting%20on%20comfortable%20furniture%20with%20natural%20materials%2C%20peaceful%20contemporary%20home%20interior%20with%20warm%20earth%20tones%20and%20inviting%20atmosphere%2C%20serene%20residential%20space%20with%20JELD-WEN%20style%20craftsmanship%20and%20delicate%20shadows&width=600&height=800&seq=prod-wood-soft-306&orientation=portrait',
      title: t('products.product6'),
      description: t('products.product6Desc'),
      brand: 'JELD-WEN',
      link: '/wood-windows-doors'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Welcoming%20home%20entrance%20with%20elegant%20fiberglass%20door%20at%20golden%20hour%2C%20soft%20warm%20porch%20lighting%20creating%20inviting%20front%20entry%2C%20gentle%20evening%20glow%20on%20craftsman%20style%20door%20with%20decorative%20glass%2C%20peaceful%20residential%20exterior%20with%20lush%20landscaping%20and%20warm%20ambient%20light%2C%20serene%20modern%20home%20entrance%20with%20natural%20materials%20and%20comfortable%20atmosphere&width=600&height=800&seq=prod-fiber-soft-307&orientation=portrait',
      title: t('products.product7'),
      description: t('products.product7Desc'),
      brand: 'JELD-WEN',
      link: '/fiberglass-entry-doors'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20glass%20facade%20with%20soft%20natural%20daylight%20and%20gentle%20reflections%2C%20peaceful%20office%20building%20exterior%20with%20clean%20glass%20panels%20and%20warm%20ambient%20lighting%2C%20serene%20contemporary%20commercial%20architecture%20with%20delicate%20shadows%20and%20inviting%20atmosphere%2C%20tranquil%20business%20space%20with%20floor%20to%20ceiling%20glass%20and%20soft%20sky%20reflections%2C%20comfortable%20professional%20environment%20with%20natural%20light%20and%20calming%20tones&width=600&height=800&seq=prod-comm-soft-308&orientation=portrait',
      title: t('products.product8'),
      description: t('products.product8Desc'),
      brand: 'Milgard',
      link: '/commercial-glass'
    }
  ];

  return (
    <section ref={sectionRef} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className={`flex flex-col md:flex-row md:items-end md:justify-between mb-14 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <div>
            <p className="text-amber-700 text-xs font-semibold tracking-[0.2em] mb-4 uppercase">{t('products.badge')}</p>
            <h2 className="text-3xl md:text-4xl font-light text-stone-800">
              {t('products.title')}
            </h2>
          </div>
          <p className="text-stone-500 text-sm max-w-md leading-relaxed mt-4 md:mt-0 font-light">
            {t('products.subtitle')}
          </p>
        </div>

        {/* Brand Tags */}
        <div className="flex items-center gap-4 mb-10">
          <div className="flex items-center gap-2.5 px-5 py-2.5 bg-amber-50/60 rounded-full border border-amber-100">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-award-line text-amber-600 text-sm"></i>
            </div>
            <span className="text-stone-700 text-xs font-medium tracking-wide">Milgard Windows</span>
          </div>
          <div className="flex items-center gap-2.5 px-5 py-2.5 bg-amber-50/60 rounded-full border border-amber-100">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-award-line text-amber-600 text-sm"></i>
            </div>
            <span className="text-stone-700 text-xs font-medium tracking-wide">JELD-WEN</span>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {products.map((product, index) => (
            <a 
              key={index}
              href={product.link}
              className={`group bg-white rounded-xl overflow-hidden border border-stone-100 hover:border-amber-200 hover:shadow-xl transition-all duration-500 cursor-pointer ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              <div className="relative overflow-hidden" style={{ width: '100%', height: '260px' }}>
                <img 
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-semibold text-stone-800 mb-1.5">{product.title}</h3>
                <p className="text-stone-400 text-xs leading-relaxed mb-4">{product.description}</p>
                <span className="text-amber-700 text-xs font-medium flex items-center gap-2 group-hover:gap-3 transition-all whitespace-nowrap">
                  {t('products.viewDetails')}
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}